"use client";
import XIcon from "public/assets/footerIcons/x.svg";
import FacebookIcon from "public/assets/footerIcons/facebook.svg";
import LinkedinIcon from "public/assets/footerIcons/linkedin.svg";
import InstagramIcon from "public/assets/footerIcons/instagram.svg";
import PinterestIcon from "public/assets/footerIcons/pinterest.svg";
import RedditIcon from "public/assets/footerIcons/reddit.svg";
import QuoraIcon from "public/assets/footerIcons/quora.svg";
import YoutubeIcon from "public/assets/footerIcons/youtube.svg";
import Link from "next/link";
import { cx } from "lib/cx";
import Image from "next/image";

import {
  ChatBubbleLeftRightIcon,
  DocumentTextIcon,
  EnvelopeIcon,
  PencilIcon,
  PencilSquareIcon,
  CurrencyDollarIcon,
  UserGroupIcon,
} from "@heroicons/react/24/outline";

export const Footer = () => {
  return (
    <footer className="bg-white pb-8 pt-12 shadow-[0_-2px_7px_-1px_rgba(0,0,0,0.1)]">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 gap-8 max-md:text-center md:grid-cols-2 lg:grid-cols-4">
          {/* Brand Section */}
          <div className="space-y-4">
            <div className="mx-auto flex w-fit items-center gap-1 md:mx-0 lg:gap-2">
              <div className="relative h-[92px] w-[85px] lg:h-[97px] lg:w-[90px] xl:h-[107px] xl:w-[100px] 2xl:h-[127px] 2xl:w-[120px]">
                <Image
                  src="/assets/resumemateFooterLogo.svg"
                  alt="ResumeMate"
                  fill={true}
                />
              </div>
              <div className="font-montserrat text-[10px] font-semibold leading-3 md:text-xs md:leading-3 lg:text-xs lg:leading-3 xl:text-sm xl:leading-4 2xl:text-base 2xl:leading-4">
                <span className="text-[#1C75BC]">Resume</span> <br />
                <span className="text-[#27AAE1]">Mate.io</span>
              </div>
            </div>
            <p className="text-sm text-gray-600 max-md:mx-auto max-md:w-[80%] lg:w-full lg:text-base">
              Craft your perfect resume with our professional tools and
              services.
            </p>
          </div>

          {/* Services Section */}
          <div>
            <h3 className="mb-4 text-lg font-semibold text-gray-900">
              Services
            </h3>
            <ul className="space-y-3">
              <li>
                <Link
                  href="/resume-builder"
                  className="flex items-center gap-2 text-gray-600 hover:text-[#1C75BC] max-md:justify-center"
                >
                  <DocumentTextIcon className="h-4 w-4" /> Templates
                </Link>
              </li>
              <li>
                <Link
                  href="/resume-builder"
                  className="flex items-center gap-2 text-gray-600 hover:text-[#1C75BC] max-md:justify-center"
                >
                  <PencilIcon className="h-4 w-4" /> Resume Builder
                </Link>
              </li>
              <li>
                <Link
                  href="/upload-resume"
                  className="flex items-center gap-2 text-gray-600 hover:text-[#1C75BC] max-md:justify-center"
                >
                  <Image
                    className=""
                    src="/icons/checkScoreBlack.svg"
                    alt="score check icon"
                    width={15}
                    height={15}
                    loading="eager"
                  />{" "}
                  Score-check
                </Link>
              </li>
              <li>
                <Link
                  href="/affiliate"
                  className="flex items-center gap-2 text-gray-600 hover:text-[#1C75BC] max-md:justify-center"
                >
                  <CurrencyDollarIcon className="h-4 w-4" />
                  Affiliate Marketing
                </Link>
              </li>
              <li>
                <Link
                  href="/referral"
                  className="flex items-center gap-2 text-gray-600 hover:text-[#1C75BC] max-md:justify-center"
                >
                  <UserGroupIcon className="h-4 w-4" />
                  Referral Program
                </Link>
              </li>
              <li>
                <Link
                  href="/resume-writing"
                  className="flex items-center gap-2 text-gray-600 hover:text-[#1C75BC] max-md:justify-center"
                >
                  <PencilSquareIcon className="h-4 w-4" /> Resume Writing
                </Link>
              </li>
              <li>
                <Link
                  href="https://wa.me/918618147607"
                  className="flex items-center gap-2 text-gray-600 hover:text-[#1C75BC] max-md:justify-center"
                >
                  <ChatBubbleLeftRightIcon className="h-4 w-4" /> Consult Now
                  for Free
                </Link>
              </li>
              {/* <li>
                <Link
                  href="/resume-writing/consultation"
                  className="flex items-center gap-2 text-gray-600 hover:text-[#1C75BC] max-md:justify-center"
                >
                  <ChatBubbleLeftRightIcon className="h-4 w-4" /> Consultation
                </Link>
              </li> */}
            </ul>
          </div>

          {/* Legal Section */}
          <div>
            <h3 className="mb-4 text-lg font-semibold text-gray-900">Legal</h3>
            <ul className="space-y-3">
              <li>
                <Link
                  href="/privacy-policy"
                  className="text-gray-600 hover:text-[#1C75BC]"
                >
                  Privacy Policy
                </Link>
              </li>
              <li>
                <Link
                  href="/refund-policy"
                  className="text-gray-600 hover:text-[#1C75BC]"
                >
                  Refund Policy
                </Link>
              </li>
              <li>
                <a
                  href="/terms-and-conditions"
                  className="text-gray-600 hover:text-[#1C75BC]"
                >
                  Terms & Conditions
                </a>
              </li>
              <li>
                <Link
                  href="mailto:help@resumemate.io"
                  className="flex items-center gap-2 text-gray-600 hover:text-[#1C75BC] max-md:justify-center"
                >
                  <EnvelopeIcon className="h-4 w-4" /> help@resumemate.io
                </Link>
              </li>
            </ul>
          </div>

          {/* Social Media Section */}
          <div>
            <h3 className="mb-4 text-lg font-semibold text-gray-900">
              Connect With Us
            </h3>
            <div className="grid grid-cols-4 gap-4 max-md:justify-items-center">
              <Link href="https://x.com/resume_mate" target="_blank">
                <XIcon
                  className={cx(
                    "h-auto w-[18px] lg:w-[21px] xl:w-[26px] 2xl:w-[31px]"
                  )}
                />
              </Link>
              <Link
                href="https://www.linkedin.com/company/resume-mate/"
                target="_blank"
              >
                <LinkedinIcon
                  className={cx(
                    "h-auto w-[18px] lg:w-[21px] xl:w-[26px] 2xl:w-[31px]"
                  )}
                />
              </Link>
              <Link
                href="https://www.instagram.com/resumemate.io/"
                target="_blank"
              >
                <InstagramIcon
                  className={cx(
                    "h-auto w-[18px] lg:w-[21px] xl:w-[26px] 2xl:w-[31px]"
                  )}
                />
              </Link>
              <Link href="https://www.youtube.com/@resumemate" target="_blank">
                <YoutubeIcon
                  className={cx(
                    "h-auto w-[18px] lg:w-[21px] xl:w-[26px] 2xl:w-[31px]"
                  )}
                />
              </Link>
              <Link
                href="https://www.facebook.com/profile.php?id=61566772433189"
                target="_blank"
              >
                <FacebookIcon
                  className={cx(
                    "h-auto w-[18px] lg:w-[21px] xl:w-[26px] 2xl:w-[31px]"
                  )}
                />
              </Link>
              <Link
                href="https://www.pinterest.com/resumemate/"
                target="_blank"
              >
                <PinterestIcon
                  className={cx(
                    "h-auto w-[18px] lg:w-[21px] xl:w-[26px] 2xl:w-[31px]"
                  )}
                />
              </Link>
              <Link
                href="https://www.reddit.com/r/ResumeBuildersHub/?rdt=34063"
                target="_blank"
              >
                <RedditIcon
                  className={cx(
                    "h-auto w-[18px] lg:w-[21px] xl:w-[26px] 2xl:w-[31px]"
                  )}
                />
              </Link>
              <Link href="https://resumemate.quora.com/" target="_blank">
                <QuoraIcon
                  className={cx(
                    "h-auto w-[18px] lg:w-[21px] xl:w-[26px] 2xl:w-[31px]"
                  )}
                />
              </Link>
            </div>
          </div>
        </div>

        {/* Copyright Section */}
        <div className="mt-12 border-t border-gray-200 pt-8">
          <p className="text-center text-sm text-gray-500">
            © {new Date().getFullYear()} Resumemate. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
};
